import type { OrderDashboardReport } from '@/api/hooks/useOrderDashboard'
import { formatCount, formatPercent } from '@/utils/stringFormatters'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Card } from 'antd'
import { TONE_COLORS, percentageTone } from './metrics'

interface OverviewCardProps {
  report: OrderDashboardReport | undefined
  loading: boolean
}

interface OverviewStatProps {
  label: string
  value: string
  color?: string
}

function OverviewStat({ label, value, color }: OverviewStatProps) {
  return (
    <Vertical gap={2} style={{ flex: 1, minWidth: 0 }}>
      <Texto
        appearance='hint'
        weight={600}
        textTransform='uppercase'
        style={{ fontSize: 11, letterSpacing: 0.5 }}
      >
        {label}
      </Texto>
      <Texto weight='bold' style={{ fontSize: 24, color }}>
        {value}
      </Texto>
    </Vertical>
  )
}

/**
 * Window totals, straight off the top level of the report -- no rollup needed.
 */
export function OverviewCard({ report, loading }: OverviewCardProps) {
  const highTone = percentageTone(report?.high_events_percentage)
  const allTone = percentageTone(report?.all_events_percentage)

  return (
    <Card size='small' loading={loading}>
      <Horizontal gap={16}>
        <OverviewStat
          label='High Events'
          value={formatPercent(report?.high_events_percentage)}
          color={highTone ? TONE_COLORS[highTone] : undefined}
        />
        <OverviewStat
          label='All Events'
          value={formatPercent(report?.all_events_percentage)}
          color={allTone ? TONE_COLORS[allTone] : undefined}
        />
        <OverviewStat label='Orders' value={formatCount(report?.num_orders)} />
        <OverviewStat
          label='Failed (High)'
          value={formatCount(report?.orders_failed_high)}
        />
      </Horizontal>
    </Card>
  )
}
